import { Dispatch, IAppState } from 'shared/common/state';
import { EMPTY_STATE_TELEMETRY } from 'shared/constants/emptyStateTelemetry';
import { IApplicationContext } from 'shared/types/applicationContext';

import { TJsonQuery } from '../../../packages/JsonQuery';
import { resetLoading, setLoading } from '../search';

/**
 * Применяет jsonQuery из блока пустой выдачи: и у каждого тега, и у действия ручка поиска
 * возвращает готовый jsonQuery.
 *
 * Применяет его микрофронт фильтров — так он обновляет и свои контролы, и свои теги, — после
 * чего эмитит `filters:updated`, по которому хост перезапрашивает выдачу (см. useFiltersUpdatedEvent).
 * Поэтому здесь только включаем загрузку и ждём события: сами за выдачей не ходим.
 */
export function applyEmptyStateJsonQuery(jsonQuery: TJsonQuery) {
  return async (dispatch: Dispatch, _getState: () => IAppState, context: IApplicationContext) => {
    const { logger, microfrontendsAPI, microfrontendsRegistry, telemetry } = context;

    if (!microfrontendsAPI || !microfrontendsRegistry.microfrontend('desktop-filters-micro-frontend')) {
      return;
    }

    dispatch(setLoading());

    try {
      await microfrontendsAPI.getDesktopFiltersMicrofrontendApi().setJsonQuery(jsonQuery);
    } catch (error) {
      dispatch(resetLoading());

      telemetry.increment(EMPTY_STATE_TELEMETRY.tagApplyError);
      logger.error(error, { degradation: 'Применение фильтров из блока пустой выдачи' });
    }
  };
}
